import {
	createStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const styles = (theme: Theme) => {
	return createStyles({
		administrationNavigation_container: {
			margin: theme.spacing(2, 0, 1, 0),
			display: 'flex',
			flexDirection: 'column',
		},
		administrationNavigation_hide: {
			padding: theme.spacing(0, 2, 0, 2),
			display: 'flex',		
		},
		administrationNavigation_hideLabel: {
			color: theme.palette.grey[400],
			cursor: 'pointer',
		},
		administrationNavigation_hideButton: {
			color: theme.palette.grey[400],
			padding: theme.spacing(0),
			marginLeft: theme.spacing(.5),
		},
		administrationNavigation_expandButton: {
			color: theme.palette.info.main,
			padding: theme.spacing(0),
			marginLeft: theme.spacing(.5),
		},
	});
}

export default styles;
